<template>
    <div class="common-body-view">
        <div  class="common-title">
            <van-icon @click="back" name="arrow-left" color="#5e5e5e" size="20"/>
            <span class="common-title-text">连点器场景配置</span>
        </div>

        <div class="main">
            <div class="main-body">
                <div style="font-size: 14px;color: #333333">
                    基础信息
                </div>

                <div class="input-view">
                    <van-field label="场景名" label-width="70" maxlength="20" placeholder="请输入场景名" class="common-input" v-model="name" />
                </div>

                <div class="input-view" style="">
                    <van-field label="循环次数" label-width="70" type="digit" max="999" maxlength="3" placeholder="无限" class="common-input" v-model="loopNum" >
                        <template v-slot:right-icon>
                            次
                        </template>
                    </van-field>
                </div>

                <div class="input-view">
                    <van-field label="循环间隔" label-width="70" type="digit" maxlength="6" placeholder="每个循环的间隔" class="common-input" v-model="loopInterval" >
                        <template v-slot:right-icon>
                            毫秒
                        </template>
                    </van-field>
                </div>

                <div style="font-size: 14px;color: #333333;margin-top: 10px;">
                    点击列表
                </div>

                <div style="display: flex;margin-top: 10px;color: #888888;font-size: 14px;margin-bottom: 10px;">
                    <div style="width: 50px;">序号</div>
                    <div style="flex: 1;text-align: center;">触发间隔</div>
                    <div style="width: 80px;text-align: center;">删除</div>
                </div>

                <div v-for="(item,index) in updatePointList" style="display: flex;align-items: center;margin-top: 2px;">
                    <div style="width: 50px;padding-left: 5px;box-sizing: border-box;font-size: 16px;color: #888888;">
                        {{index + 1}}
                    </div>
                    <div style="flex: 1;display: flex;justify-content: center;">
                        <div class="input-view" style="margin-top: 0;height: 30px;">
                            <van-field label-width="0" maxlength="6" type="digit" placeholder="1000" style="width: 110px;height: 28px;padding: 2px 10px;"
                                       v-model="item.timeInterval" >
                                <template v-slot:right-icon>
                                    毫秒
                                </template>
                            </van-field>
                        </div>
                    </div>

                    <div style="width: 80px;height: 20px;text-align: center;">
                        <van-icon @click="deletePoint(index)" name="cross" style="cursor: pointer;margin-top: 6px;" size="18" color="#aaaaaa"/>
                    </div>

                </div>

            </div>


            <div style="width: 100%; display: flex;justify-content: space-between;height: 35px;padding: 5px 15px 0;box-sizing: border-box;">
                <van-button  @click="exitPlan" type="info" round style="height: 30px;width: 110px;font-size: 13px;" color="#888888">
                    退出
                </van-button>

                <van-button  @click="save" type="info" round :loading="showLoading" style="height: 30px;width: 110px;font-size: 13px;" color="#4394FD">
                    保存场景
                </van-button>
            </div>

        </div>
    </div>
</template>

<script>
    import { Toast, Dialog } from 'vant';

    export default {
        name: "auto-click-setting",
        components: {
        },
        data() {
            return {
                showLoading: false,
                name: '',
                loopNum: '',
                loopInterval: '0',
                updatePointList: [],
                parent: this.$parent.$parent,
                planList: [],
                createOrUpdatePlan: 0,
            }
        },
        mounted () {
            console.log('mounted执行了');
            this.planList = JSON.parse(localStorage.getItem('autoClickPlanList')) || [];
            if (this.parent.createOrUpdatePlan === 1) {//新增
                let plan = this.parent.autoClickPlan;
                this.name = plan.name ? plan.name : '连点器场景' + (this.planList.length + 1);
                this.loopNum = plan.loopNum;
                this.loopInterval = plan.loopInterval;
            }
            else {
                let plan = this.planList[this.parent.selectAutoClickPlanIndex];
                this.name = plan.name;
                this.loopNum = plan.loopNum;
                this.loopInterval = plan.loopInterval;
            }

            this.updatePointList = this.parent.autoClickPointList;
        },
        methods: {
            back(){
                this.parent.autoClickPlan = {
                    name: this.name,
                    loopNum: this.loopNum,
                    loopInterval: this.loopInterval,
                }
                this.parent.autoClickSettingShow = false;
            },
            exitPlan() {
                let msg = '确认要退出吗';
                Dialog.confirm({
                    message: msg,
                }).then(() => {
                    this.parent.exitAutoClickPlan();
                }).catch(() => {
                });
            },
            save() {
                if (!this.name) {
                    Toast('请输入场景名');
                    return ;
                }
                if (!!this.loopNum && this.loopNum <= 0) {
                    Toast('请输入正确的循环次数');
                    return ;
                }
                if (this.parent.autoClickPointList.length === 0) {
                    Toast('请添加至少一个触点');
                    return ;
                }
                if (!this.loopInterval) {
                    Toast('请输入循环间隔');
                    return ;
                }

                let clickPlan = {
                    pointList: this.parent.autoClickPointList,
                    name: this.name,
                    loopNum: this.loopNum,
                    loopInterval: this.loopInterval,
                }

                if (this.parent.createOrUpdatePlan === 1) {//新增
                    if (this.planList.length >= 20) {
                        Toast('最多保存20个场景');
                        return ;
                    }

                    this.planList.push(clickPlan);
                    this.parent.createOrUpdatePlan = 2;
                    this.parent.selectAutoClickPlanIndex = this.planList.length - 1;
                }
                else {//修改
                    this.planList[this.parent.selectAutoClickPlanIndex] = clickPlan;
                }

                localStorage.setItem('autoClickPlanList', JSON.stringify(this.planList));
                Toast('保存成功');

                this.back();
            },
            deletePoint(index) {
                Dialog.confirm({
                    message: '确认删除 ' + (index + 1) + ' 号触点吗?',
                }).then(() => {
                    this.parent.autoClickPointList.splice(index, 1);
                }).catch(() => {
                });
            },
        }
    }
</script>

<style scoped>
    .common-body-view {
        border-radius: 10px;
        width: 100%;
        height: 320px;
        box-sizing: border-box;
        max-width: 400px;
        position: relative;
        margin: 0 auto;
        background: url("../assets/dialog-bg.png");
        background-size: 100% 100%;
    }

    .common-title {
        height: 50px;
        display: flex;
        align-items: center;
        padding-right: 20px;
        padding-left: 15px;
    }

    .common-title-text {
        font-size: 16px;
        font-weight: bold;
        margin-left: 8px;
        color: #5e5e5e;
    }

    .main{
        width: 95%;
        height: 270px;
        border-radius: 5px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 5px 5px;
        box-sizing: border-box;
        position: relative;
    }
    .main-body {
        width: 100%;
        padding: 0 15px 15px;
        box-sizing: border-box;
        height: 230px;
        overflow-y: auto;
        text-align: left;
    }

    .main-body {
        -ms-overflow-style: none;  /* IE 和 Edge */
        scrollbar-width: none;/* Firefox */
    }
    .main-body::-webkit-scrollbar {
        display: none;/* 兼容 Chrome, Opera, 和 Safari */
    }

    .input-view{
        width: 100%;
        height: 38px;
        display: flex;
        margin-top: 5px;
        //box-shadow: 2px 2px 10px 3px rgba(0,0,0,.1);
    }

    .common-input {
        font-size: 13px;
        height: 38px;
    }

    .van-cell {
        padding: 7px 10px;
        background-color: #f2f2f2;
        border-radius: 8px;
    }

    .input-view ::-webkit-input-placeholder {
        color: #888888;
    }
    .input-view :-moz-placeholder {
        color: #888888;
    }
    .input-view ::-moz-placeholder {
        color: #888888;
    }

</style>